import { PublicUtility } from "@entity/domain/models/public-utility/public-utility.model";

export class CreatePublicUtility {
    constructor(
        public organizationType: PublicUtility["organizationType"],
        public entity: PublicUtility["entity"],
        public date: PublicUtility["date"],
    ) {}
}
